import { gql } from 'apollo-angular';

export const GET_PROFILES = gql`
  query roles($search: String) {
    roles(search: $search) {
      id
      profileName
      description
      isDefault
      status
      usersCount
      rolePermissions {
        id
        profileId
        permissionId
      }
      users {
        id
        email
        password
        firstName
        lastName
        status
        resetToken
        profileId
      }
    }
  }
`;

export const GET_MODULES = gql`
  query getModulesList {
    getModulesList {
      id
      parentModuleId
      moduleName
      url
      createdAt
      updatedAt
      deletedAt
      isMenu
      parentModuleData {
        moduleName
      }
      childModules {
        id
        moduleName
      }
    }
  }
`;

export const GET_PROFILE_BY_ID = gql`
  query role($id: Int!) {
    role(id: $id) {
      id
      profileName
      description
      isDefault
      status
      rolePermissions {
        id
        profileId
        permissionId
      }
      users {
        firstName
        lastName
        email
        # status
      }
    }
  }
`;

export const GET_PERMISSIONS = gql`
  query permissions($search: String) {
    permissions(search: $search) {
      id
      permissionName
      description
      createdBy
      status
      rolePermissions {
        id
        profileId
        # profileData
        moduleId
        # moduleData
        permissionId
        # permission
      }
    }
  }
`;

export const GET_PERMISSION_BY_ID = gql`
  query getPermissionsByProfile($profileId: Int!) {
    getPermissionsByProfile(profileId: $profileId) {
      moduleId
      moduleName
      description
      permissions {
        permissionId
        permissionName
        displayName
        description
        hasPermission
      }
    }
  }
`;
